import { useState } from "react";
import { Search } from "lucide-react";
import { contentTypes } from "../../data/categories";

const ContentTypeModal = ({ filters, setFilters, onClose }) => {
  const selected = filters.contentType || [];
  const [search, setSearch] = useState("");

  const filteredTypes = contentTypes.filter((type) =>
    type.toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (item) => {
    setFilters({
      ...filters,
      contentType: selected.includes(item)
        ? selected.filter((i) => i !== item)
        : [...selected, item],
    });
  };

  return (
    <div className="w-full relative mt-2">

      {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>

      {/* Header */}
      <h2 className="text-lg font-semibold mb-4">Select Content Type</h2>

      {/* Search */}
      <div className="relative mb-4">
        <Search
          size={18}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />

        <input
          type="text"
          placeholder="Search content type"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border rounded-lg pl-10 pr-3 py-2 focus:outline-none focus:border-gray-400"
        />
      </div>

      {/* List */}
      <div className="max-h-[220px] overflow-y-auto space-y-3 pr-1">

        {filteredTypes.map((type) => (
          <label
            key={type}
            className="flex items-center gap-3 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={selected.includes(type)}
              onChange={() => toggle(type)}
              className="w-4 h-4"
            />

            <span className="text-sm">{type}</span>
          </label>
        ))}
      </div>

      {/* Footer */}
      <div className="flex justify-between gap-6 mt-2 border-t pt-2">
        <button
          onClick={() => {
            setFilters({ ...filters, contentType: [] });
            onClose();
          }}
          className="underline text-sm text-gray-700 hover:text-gray-900"
        >
          Clear
        </button>
        <button
          onClick={onClose}
          className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition"
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default ContentTypeModal;



// import { contentTypes } from "../../data/categories";

// const ContentTypeModal = ({ filters, setFilters, platform, onClose }) => {
//     const selected = filters.contentType || [];
//     const types = contentTypes;
  
//     const toggle = (item) => {
//       setFilters({
//         ...filters,
//         contentType: selected.includes(item)
//           ? selected.filter(i => i !== item)
//           : [...selected, item]
//       });
//     };
  
//     return (
//       <>
//         <h2 className="text-xl font-semibold mb-6">Content Type</h2>
  
//         <div className="space-y-4">
//           {types.map(type => (
//             <label key={type} className="flex items-center gap-3">
//               <input
//                 type="checkbox"
//                 checked={selected.includes(type)}
//                 onChange={() => toggle(type)}
//                 className="w-5 h-5"
//               />
//               <span className="text-lg">{type}</span>
//             </label>
//           ))}
//         </div>
  
//         <div className="flex justify-between mt-8">
//           <button
//             onClick={() => {
//               setFilters({ ...filters, contentType: [] });
//               onClose();
//             }}
//             className="underline"
//           >
//             Clear
//           </button>
//           <button
//             onClick={onClose}
//             className="bg-orange-500 text-white px-8 py-3 rounded-xl"
//           >
//             Save
//           </button>
//         </div>
//       </>
//     );
//   };
  
//   export default ContentTypeModal;
  